
define('text!app/board/templates/draftInfoRoundPickTemplate.html',[],function () { return '<tr>\r\n\t<td class="playerRankingsStatusRowTitle">{{ pickNum }}</td>\r\n\t<td class="playerRankingsStatusRowName">{{ name }}</td>\t\r\n</tr>';});
